import { GenericSocketMessage, Meeting, SetUnreadCountSocketMessage } from '../models/chat';
import { MeetingsStore } from './meetings.store';
import { AuthServiceInterface } from './AuthServiceInterface';

export class ChatMeetingService {
    static $inject = ['$http', 'GuidFactory', '$socket', 'MeetingsStore', 'AuthService'];

    private meetings$?: Rx.Observable<Meeting[]>;

    private ignoredGuids: string[] = [];

    constructor(
        private $http: angular.IHttpService,
        private guidFactory: any,
        private $socket: any,
        private meetingsStore: MeetingsStore,
        private authService: AuthServiceInterface
    ) {
        $socket.on('chat', (msg: GenericSocketMessage) => {
            if (this.ignoredGuids.includes(msg.guid)) return;

            switch (msg.action) {
                case 'set_unread_count':
                    return this.onSetUnreadCount(msg);
            }
        });
    }

    onSetUnreadCount({ payload }: SetUnreadCountSocketMessage) {
        if (payload.userId === this.authService.getUserId()) {
            this.meetingsStore.dispatchSetUnreadCount(payload.meetingId, payload.count);
        }
    }

    getMeetings(): Rx.Observable<Meeting[]> {
        if (!this.meetings$) {
            this.meetings$ = Rx.Observable.fromPromise(this.fetchMeetings()).shareReplay(1);
        }

        return this.meetings$;
    }

    fetchMeetings(): ng.IPromise<Meeting[]> {
        return this.$http.get<Meeting[]>('/api/v2.0/chat/meetings').then((response) => response.data);
    }

    /**
     * Returns a JWT token required to authorize against "new" chat server.
     * The JWT contains a list of chat rooms we can join as users.
     */
    getChatKey(): angular.IPromise<string> {
        return this.$http.get<string>('/api/v2.0/chat/key').then((response) => response.data);
    }

    updateMeetingLastSeenAt(meetingId: number): angular.IPromise<any> {
        const guid = `C-${this.guidFactory.Generate()}`;

        this.ignoredGuids.push(guid);

        if (!meetingId) {
            return Promise.resolve();
        }

        return this.$http.post(
            '/api/v2.0/chat/unread-bar/',
            { meeting: meetingId },
            { headers: { 'X-Ph-Guid': guid } }
        );
    }
}

angular.module('tradersyard').service('ChatMeetingService', ChatMeetingService);
